import React from "react";
import { useNavigate } from "react-router-dom";
import CreateAccountForm from "../../components/CreateAccountForm";
import "./Create.css";

const FRONTEND_URL = process.env.REACT_APP_FRONTEND_URL || "/backend";

export default function CreatePSW() {
  const navigate = useNavigate();

  return (
    <CreateAccountForm
      title="Create PSW Account"
      buttonText="Create PSW Account"
      endpoint="/users/create-psw"
      showCode={true}
      onSuccess={() => navigate(`${FRONTEND_URL}/login`)}
      onNavigateToLogin={() => navigate(`${FRONTEND_URL}/login`)}
      onNavigateToOtherPage={() => navigate(`${FRONTEND_URL}/create`)}
    />
  );
}
